/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'wnharomEgwVndY3XDWMj6u.png': { uri: '/images/wnharomEgwVndY3XDWMj6u.png' },
'axn1sRCQDXLE7vJ85Wmo6Y.png': { uri: '/images/axn1sRCQDXLE7vJ85Wmo6Y.png' },
'68UM7eMpDhsdZxWk5XJnmG.png': { uri: '/images/68UM7eMpDhsdZxWk5XJnmG.png' },
'u3gioMZgZYjXyZhZqzvnod.png': { uri: '/images/u3gioMZgZYjXyZhZqzvnod.png' },
'uDSxCN6i19gmPLRdPAp9s2.png': { uri: '/images/uDSxCN6i19gmPLRdPAp9s2.png' },
'upm6HHcwmq9zGgL8UztPPk.png': { uri: '/images/upm6HHcwmq9zGgL8UztPPk.png' },
'5svVYU758Ni8SnrKRkjnog.jpg': { uri: '/images/5svVYU758Ni8SnrKRkjnog.jpg' },
'iX579AfwUKDs3yxq3qA2PF.png': { uri: '/images/iX579AfwUKDs3yxq3qA2PF.png' },
'uinL6nZZoXoMtNBNqmphU7.png': { uri: '/images/uinL6nZZoXoMtNBNqmphU7.png' },
'4ZB6hka6Eag3tJiTz61nRE.png': { uri: '/images/4ZB6hka6Eag3tJiTz61nRE.png' },
'j94RfWcxF8qRDQ8noba8zZ.png': { uri: '/images/j94RfWcxF8qRDQ8noba8zZ.png' },
'gUXCVfxtzJ9uZXqR2dztr4.png': { uri: '/images/gUXCVfxtzJ9uZXqR2dztr4.png' },
'rX4R2pjXJD3D5AzNF8NfFe.png': { uri: '/images/rX4R2pjXJD3D5AzNF8NfFe.png' },
'aK5XQqHNN5s2YqeznJYeQZ.png': { uri: '/images/aK5XQqHNN5s2YqeznJYeQZ.png' },
'9KkSdiaNzJ2oW3DMfMKawR.png': { uri: '/images/9KkSdiaNzJ2oW3DMfMKawR.png' },
'geP1NxCJA856MerKWy9zpz.png': { uri: '/images/geP1NxCJA856MerKWy9zpz.png' },
'dZAD9iLeMZ3a77e8nTHp3u.png': { uri: '/images/dZAD9iLeMZ3a77e8nTHp3u.png' },
'xBd4Y31bjqKqVKeUvPLKX9.png': { uri: '/images/xBd4Y31bjqKqVKeUvPLKX9.png' },
'99jovPF1wHhcrxpmp8Lfpa.png': { uri: '/images/99jovPF1wHhcrxpmp8Lfpa.png' },
'bGWKqUD6WWPB57pFShHeNp.png': { uri: '/images/bGWKqUD6WWPB57pFShHeNp.png' },
'acZV93TvpKQKqhtxvTX6FK.png': { uri: '/images/acZV93TvpKQKqhtxvTX6FK.png' },
'pHFPzZs4KRoYkx2hjsLAGx.png': { uri: '/images/pHFPzZs4KRoYkx2hjsLAGx.png' },
'avzmLLqg1QAZDyjTJ6KPCt.jpg': { uri: '/images/avzmLLqg1QAZDyjTJ6KPCt.jpg' },
'f6YxXz3ockaMkW6WEu9MLV.png': { uri: '/images/f6YxXz3ockaMkW6WEu9MLV.png' },
'hd2rHv9mnUckcb8paAM8BK.png': { uri: '/images/hd2rHv9mnUckcb8paAM8BK.png' },
'cAHUhcxpFikvd2CdkATFgB.png': { uri: '/images/cAHUhcxpFikvd2CdkATFgB.png' },
'nXJYHnPa3h5HzJTNTPT8p7.png': { uri: '/images/nXJYHnPa3h5HzJTNTPT8p7.png' },
'f874f62aT48eH1iZqqTeH4.png': { uri: '/images/f874f62aT48eH1iZqqTeH4.png' },
'vfRYXeCNcG26ZuFZ9QdfXv.png': { uri: '/images/vfRYXeCNcG26ZuFZ9QdfXv.png' },
'foYiXAviUkjdUS4yRTaLwq.png': { uri: '/images/foYiXAviUkjdUS4yRTaLwq.png' },
'whB1tUNH5RHgsx1AmkgR4Y.png': { uri: '/images/whB1tUNH5RHgsx1AmkgR4Y.png' },
'ujLPiCe9wxfpke7yUmzw1h.png': { uri: '/images/ujLPiCe9wxfpke7yUmzw1h.png' },
'cdcCchVhEnjZ7vvV7q6X6P.png': { uri: '/images/cdcCchVhEnjZ7vvV7q6X6P.png' },
'iMR7YWHj9fQ8dTbQqgboGz.png': { uri: '/images/iMR7YWHj9fQ8dTbQqgboGz.png' },
'9WLrDpMURUpUebt8RbkBkE.png': { uri: '/images/9WLrDpMURUpUebt8RbkBkE.png' },
'7BcevN6Yq3DbUCmbpA9GmB.png': { uri: '/images/7BcevN6Yq3DbUCmbpA9GmB.png' },
'w1rXLT2sgzt8bKYATUwPKU.png': { uri: '/images/w1rXLT2sgzt8bKYATUwPKU.png' },
't2RxdzXcvjYqp3fAU6gRyG.png': { uri: '/images/t2RxdzXcvjYqp3fAU6gRyG.png' },
'oEhPH52NQ38BPYhMCEiDY2.png': { uri: '/images/oEhPH52NQ38BPYhMCEiDY2.png' },
'56oTVYYXtGudqTNai4CLoB.png': { uri: '/images/56oTVYYXtGudqTNai4CLoB.png' },
'aPKoLCnvMe1S9WrnkTMKQQ.png': { uri: '/images/aPKoLCnvMe1S9WrnkTMKQQ.png' },
'8Embbu5sqQ78f6tNtmD6Gk.png': { uri: '/images/8Embbu5sqQ78f6tNtmD6Gk.png' },
'fjsqLM6R9M9u6D8NL5Q4Uw.png': { uri: '/images/fjsqLM6R9M9u6D8NL5Q4Uw.png' },
'ut5zBMcMxj8rprgsEKbhY3.jpg': { uri: '/images/ut5zBMcMxj8rprgsEKbhY3.jpg' },
'hDtNrDqYu86QNmQKU5C6r2.jpg': { uri: '/images/hDtNrDqYu86QNmQKU5C6r2.jpg' }
}

export default imageStaticSourcesByFileName
